export var AgentFunnelYMetric;
(function (AgentFunnelYMetric) {
    AgentFunnelYMetric["OBJECT_VISITS"] = "objectVisits";
    AgentFunnelYMetric["PROFILE_COMPLETENESS"] = "profileCompleteness";
    AgentFunnelYMetric["SOCIAL_COMPLETENESS"] = "socialCompleteness";
    AgentFunnelYMetric["SMARTIS_CAPTURED"] = "smartisCaptured";
    AgentFunnelYMetric["TG_BOT_AVAILABILITY"] = "tgBotAvailability";
    AgentFunnelYMetric["UNITY_SOURCES"] = "unitySources";
})(AgentFunnelYMetric || (AgentFunnelYMetric = {}));
export var AgentFunnelComparePeriod;
(function (AgentFunnelComparePeriod) {
    AgentFunnelComparePeriod["NONE"] = "none";
    AgentFunnelComparePeriod["WEEK"] = "week";
    AgentFunnelComparePeriod["MONTH"] = "month";
})(AgentFunnelComparePeriod || (AgentFunnelComparePeriod = {}));
export var AgentFunnelDataSource;
(function (AgentFunnelDataSource) {
    AgentFunnelDataSource["AGENTS"] = "agents";
    AgentFunnelDataSource["CRM"] = "crm";
    AgentFunnelDataSource["BOTH"] = "both";
})(AgentFunnelDataSource || (AgentFunnelDataSource = {}));
export const AGENT_FUNNEL_DATA_SOURCE_CHOICES = [
    AgentFunnelDataSource.AGENTS,
    AgentFunnelDataSource.CRM,
];
export var AgentQuantityStage;
(function (AgentQuantityStage) {
    AgentQuantityStage["NONE"] = "none";
    AgentQuantityStage["APPEAL"] = "appeal";
    AgentQuantityStage["LEAD"] = "lead";
    AgentQuantityStage["MEETING"] = "meeting";
    AgentQuantityStage["BOOKING"] = "booking";
    AgentQuantityStage["DEAL"] = "deal";
})(AgentQuantityStage || (AgentQuantityStage = {}));
export const AGENT_QUANTITY_STAGES = [
    AgentQuantityStage.NONE,
    AgentQuantityStage.APPEAL,
    AgentQuantityStage.LEAD,
    AgentQuantityStage.MEETING,
    AgentQuantityStage.BOOKING,
    AgentQuantityStage.DEAL,
];
/** Sentinel cell: the agent is absent from the other snapshot. Not a heatmap axis. */
export const FUNNEL_OUTSIDE_STAGE_ORDER = -1;
export const FUNNEL_OUTSIDE_Y_BUCKET = -1;
export const AGENT_FUNNEL_PERIOD_PRESETS = [1, 3, 6, 12];
export const AGENT_FUNNEL_PROFILE_COMPLETENESS_GRADATIONS = [
    0, 25, 50, 75, 100,
];
export const AGENT_FUNNEL_UNITY_NOTICE_SOURCE = '__unity_notice__';
export const AGENT_FUNNEL_UNKNOWN_DEAL_SOURCE = '__unknown__';
export const AGENT_FUNNEL_UNITY_NOTICE_SOURCE_LABEL = 'Уведомление ЮНИТИ';
export const AGENT_FUNNEL_UNKNOWN_DEAL_SOURCE_LABEL = 'Источник не указан';
